<template>
  <component :is="currentHomeComponent" :key="componentMode"></component>
</template>

<script>
import DesktopHomeView from './Home.vue'
import MobileHomeView from './MobileHome.vue'

const PHONE_MAX_WIDTH = 767
const PHONE_USER_AGENT_REGEXP = /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|Opera Mini|Mobile/i
const TABLET_USER_AGENT_REGEXP = /iPad|Tablet|PlayBook|Silk|Kindle|Nexus 7|Nexus 10|SM-T|Pad/i

const resolvePhoneLayout = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const userAgent = window.navigator.userAgent || ''
  const isTabletDevice = TABLET_USER_AGENT_REGEXP.test(userAgent)
  const isPhoneDevice = !isTabletDevice && PHONE_USER_AGENT_REGEXP.test(userAgent)

  if (isTabletDevice) {
    return false
  }

  return isPhoneDevice || window.innerWidth <= PHONE_MAX_WIDTH
}

export default {
  name: 'HomeEntryView',
  components: {
    DesktopHomeView,
    MobileHomeView
  },
  data() {
    return {
      isPhoneLayout: resolvePhoneLayout()
    }
  },
  computed: {
    currentHomeComponent() {
      return this.isPhoneLayout ? MobileHomeView : DesktopHomeView
    },
    componentMode() {
      return this.isPhoneLayout ? 'mobile-home' : 'desktop-home'
    }
  },
  mounted() {
    this.checkInviteRedirect()

    this.handleViewportChange = () => {
      this.isPhoneLayout = resolvePhoneLayout()
    }

    window.addEventListener('resize', this.handleViewportChange, { passive: true })
    this.handleViewportChange()
  },
  methods: {
    checkInviteRedirect() {
      const query = this.$route.query || {}
      const inviteCode = query.invite_code
      const qrToken = query.qr_token

      if (inviteCode || qrToken) {
        this.$router.replace({
          name: 'cloud-drive-invite',
          query: {
            invite_code: inviteCode,
            qr_token: qrToken
          }
        })
      }
    }
  },
  beforeDestroy() {
    if (this.handleViewportChange) {
      window.removeEventListener('resize', this.handleViewportChange)
    }
  }
}
</script>
